import React from 'react';
import styled, {keyframes} from 'styled-components';
import ImageLoading from '../../img/loading.gif';

class LocalSpinner extends React.Component {

    constructor(props) {
        super(props);

        const anim_rotate_spinner = keyframes`
            from{
                transform: rotate(359deg);
            }
            to{
                transform: rotate(0deg);
            }
        `;

        this.container = styled.div `
            opacity: 0.4;
            padding-top: 100px;
            text-align: center;
            .spinner_image{
                animation: ${anim_rotate_spinner} 2.5s infinite;
                display: inline-block;
                width: 140px;
                height: 140px;
                background-image: url(${ImageLoading});
                background-size: contain;
            }
        `;
    }

    render() {
        return (
            <this.container>
                <div className="spinner_image"></div>
            </this.container>
        );
    }
}

export default LocalSpinner;



// WEBPACK FOOTER //
// ./src/components/base/LocalSpinner.jsx